import React from "react";
import PropTypes from 'prop-types';
import { Button, Card, IconButton, Tooltip } from "@material-ui/core";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import YouTubeIcon from '@material-ui/icons/YouTube';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import ObjectOverride from "../ObjectOverride";
import { confirmAlert } from "react-confirm-alert";
import { Types } from "components";
import Typography from "@material-ui/core/Typography";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CardActionArea } from '@mui/material';
import APPCONFIG from "../../constants/Config";

const LOCATION_PLAN_DETAILS = {
	ffl_home: {
		name: 'FFL Home',
		tier: 1,
		limits: {acquisitions: 25, dispositions: 25, users: 1, boundBooks: 3, storage: 100000}
	},
	ffl_plus: {
		name: 'FFL Plus',
		tier: 2,
		limits: {acquisitions: 250, dispositions: 250, users: 4, boundBooks: Infinity, storage: 500000}
	},
	ffl_pro: {
		name: 'FFL Pro',
		tier: 3,
		limits: {acquisitions: 850, dispositions: 850, users: 8, boundBooks: Infinity, storage: 1000000}
	}
};

class ModuleCard extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
		this.state.key = null;
		this.state.showApiKey = false;
	}

	static propTypes = {
		price: PropTypes.string.isRequired,
		type: PropTypes.string,
		isDisabled: PropTypes.bool,
		youtubeUrl: PropTypes.string,
	};

	static defaultProps = {
		isDisabled: false,
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

	}

	//Calls Modules table
	submitModule = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = locationBinaryId;
		moduleModel.object.location = location;
		moduleModel.object.location_binary_id = locationBinaryId;
		moduleModel.parent = locationBinaryId + '-' + location;
		moduleModel.object.module = module;
		moduleModel.object.account = account;

		try {
			await moduleModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Calls Upgrades table
	submitUpgrade = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let upgradeModel = new API.BuildClass(Types.Upgrades._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		upgradeModel.object.location = location;
		upgradeModel.object.location_binary_id = locationBinaryId;
		upgradeModel.object.upgrade = module;
		upgradeModel.object.upgrade_type = this.props.moduleType;

		try {
			await upgradeModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}



	removeUpgrade = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let upgradeModel = new API.BuildClass(Types.Upgrades._name, 'POST_REMOVE_UPGRADE');

		// noinspection JSValidateTypes
		upgradeModel.object.location = location;
		upgradeModel.object.location_binary_id = locationBinaryId;
		upgradeModel.object.upgrade = module;
		upgradeModel.object.upgrade_type = this.props.moduleType;

		try {
			await upgradeModel.submit(null, 'POST_REMOVE_UPGRADE', true);
			API.Toast.success(name + " has been successfully removed!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Calls Services
	submitService = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let serviceModel = new API.BuildClass(Types.Modules_Module_Services._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		serviceModel.object.location = location;
		serviceModel.object.location_binary_id = locationBinaryId;
		serviceModel.object.upgrade = module;
		serviceModel.object.upgrade_type = this.props.moduleType;

		try {
			await serviceModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success("Support has been successfully notified!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}


	submitApiRequest = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = locationBinaryId;
		moduleModel.object.location = location;
		moduleModel.object.location_binary_id = locationBinaryId;
		moduleModel.parent = locationBinaryId + '-' + location;
		moduleModel.object.module = module;
		moduleModel.object.account = account;
		let result = null;
		try {
			result = await moduleModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}
		if(result) {
			this.setState({loading: false, showApiKey: true, apiKey: result.apiKey});
		}

	}

	//Called when any module or subscription is altered.
	refreshMarketPlace() {
		this.handleToggleModal('modalModuleLearnMore')
		if(typeof this.props.handleAfterSave === 'function') {
			this.props.handleAfterSave();
		}
	}

	//Removes Location Module
	removeModule = (pkey, binary_id, module, parent, location, locationBinaryId, name) => async () => {
		confirmAlert({
			title: 'Unsubscribe',
			message: 'Are you sure you want to unsubscribe from this Module?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true})
						let moduleModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.DELETE);
						moduleModel.object.pkey = pkey;
						moduleModel.object.binary_id = binary_id;
						moduleModel.object.location = location;
						moduleModel.object.location_binary_id = locationBinaryId;
						moduleModel.parent = binary_id + '-' + location;
						moduleModel.object.type = module;
						try {
							await moduleModel.submit(null, API.RequestType.DELETE);
							API.Toast.success(name + " has been successfully removed!", {
								position: API.Toast.POSITION.TOP_RIGHT,
								autoClose: 8000
							})
						} catch (e) {
						}
						this.refreshMarketPlace();
						this.setState({loading: false});
					}
				},
				{
					label: 'No',
					onClick: async () => {
						this.setState({loading: true})
						//Nothing
						this.setState({loading: false})
					}
				}
			]
		});
	}

	// Calls Subscriptions table
	submitSubscription = (location, location_binary_id, moduleId, account, locationSelected, name, type) => async () => {
		const currentPlanName = LOCATION_PLAN_DETAILS[locationSelected.type]?.name || locationSelected.subscriptions?.description || 'the current plan';
		confirmAlert({
			title: 'Confirm Subscription Change',
			message: `Change ${name} from ${currentPlanName} to ${type}?`,
			buttons: [
				{
					label: 'Confirm Change',
					onClick: async () => {
						this.setState({loading: true});
						let moduleModel = new API.BuildClass(Types.Locations._name, API.RequestType.UPDATE);
						moduleModel.object = {...locationSelected, type: moduleId};
						try {
							await moduleModel.submit(null, API.RequestType.UPDATE, true);
							API.Toast.success("Location: " + name + " has successfully updated their subscription plan to " + type + "!", {
								position: API.Toast.POSITION.TOP_RIGHT,
								autoClose: 8000
							})
						}
						catch (e) {
						}
						this.refreshMarketPlace();
						this.setState({loading: false})
					}
				},
				{
					label: 'Cancel',
					onClick: async () => {
						this.setState({loading: true})
						//Nothing
						this.setState({loading: false})
					}
				}
			]
		});
	}

	parseUserUsage = () => {
		const userCount = String(this.props.rootState?.userCount || '');
		const match = userCount.match(/^\s*([\d,]+)\s+out of\s+([\d,]+|unlimited)\s*$/i);
		if (!match) {
			return {count: null, limit: null};
		}

		return {
			count: Number(match[1].replace(/,/g, '')),
			limit: match[2].toLowerCase() === 'unlimited' ? Infinity : Number(match[2].replace(/,/g, ''))
		};
	}

	getNumericUsage = (amount) => {
		if (amount === null || typeof amount === 'undefined' || amount === '') {
			return null;
		}
		const numericAmount = Number(amount);
		return Number.isFinite(numericAmount) ? numericAmount : null;
	}

	getSubscriptionComparison = () => {
		const {locationSelected, moduleId, subscriptionUsage} = this.props;
		const currentPlanId = locationSelected?.type || locationSelected?.subscriptions?.id;
		const currentPlan = LOCATION_PLAN_DETAILS[currentPlanId];
		const selectedPlan = LOCATION_PLAN_DETAILS[moduleId];

		if (!currentPlan || !selectedPlan || currentPlanId === moduleId) {
			return null;
		}

		const userUsage = this.parseUserUsage();
		const currentPlanUserContribution = locationSelected.subscription && !locationSelected.archived
			? currentPlan.limits.users
			: 0;
		const selectedUserLimit = userUsage.limit === Infinity
			? Infinity
			: userUsage.limit === null
				? null
				: userUsage.limit - currentPlanUserContribution + selectedPlan.limits.users;
		const effectiveStorageLimit = this.getNumericUsage(locationSelected.data_usage_limit);
		const currentStorageLimit = effectiveStorageLimit === null ? currentPlan.limits.storage : effectiveStorageLimit;
		const retainedStorageUpgrades = Math.max(0, currentStorageLimit - currentPlan.limits.storage);
		const isDowngrade = selectedPlan.tier < currentPlan.tier;
		const metrics = [
			{
				key: 'acquisitions',
				label: 'Acquisitions this billing month',
				usage: subscriptionUsage ? this.getNumericUsage(subscriptionUsage.acq_count) : null,
				currentLimit: currentPlan.limits.acquisitions,
				selectedLimit: selectedPlan.limits.acquisitions
			},
			{
				key: 'dispositions',
				label: 'Dispositions this billing month',
				usage: subscriptionUsage ? this.getNumericUsage(subscriptionUsage.dispo_count) : null,
				currentLimit: currentPlan.limits.dispositions,
				selectedLimit: selectedPlan.limits.dispositions
			},
			{
				key: 'users',
				label: 'Account users',
				usage: userUsage.count,
				currentLimit: userUsage.limit,
				selectedLimit: selectedUserLimit
			},
			{
				key: 'storage',
				label: 'Cloud storage',
				usage: this.getNumericUsage(locationSelected.data_usage),
				currentLimit: currentStorageLimit,
				selectedLimit: selectedPlan.limits.storage + retainedStorageUpgrades,
				storage: true
			}
		];

		if (currentPlan.limits.boundBooks !== selectedPlan.limits.boundBooks) {
			metrics.splice(3, 0, {
				key: 'boundBooks',
				label: 'Additional bound books',
				usage: Array.isArray(locationSelected.location_bound_bookss) ? locationSelected.location_bound_bookss.length : null,
				currentLimit: currentPlan.limits.boundBooks,
				selectedLimit: selectedPlan.limits.boundBooks
			});
		}

		const featureChanges = [];
		if (currentPlan.tier < 2 && selectedPlan.tier >= 2) {
			featureChanges.push('Unlimited additional bound books');
		} else if (currentPlan.tier >= 2 && selectedPlan.tier < 2) {
			featureChanges.push('Unlimited additional bound books');
		}
		if (currentPlan.tier < 3 && selectedPlan.tier >= 3) {
			featureChanges.push('Unlimited NFA forms and reservations');
		} else if (currentPlan.tier >= 3 && selectedPlan.tier < 3) {
			featureChanges.push('Unlimited NFA forms and reservations');
		}

		const hasUnavailableUsage = metrics.some(metric => metric.usage === null || metric.currentLimit === null || metric.selectedLimit === null);
		return {currentPlan, selectedPlan, metrics, featureChanges, isDowngrade, hasUnavailableUsage};
	}

	formatSubscriptionAmount = (amount, storage = false) => {
		if (amount === Infinity) {
			return 'Unlimited';
		}
		if (amount === null || typeof amount === 'undefined' || Number.isNaN(amount)) {
			return 'Unavailable';
		}
		if (storage) {
			return `${Math.round(amount / 1000).toLocaleString()} MB`;
		}
		return Number(amount).toLocaleString();
	}

	getSubscriptionProgressWidth = (usage, limit) => {
		if (usage === null || limit === null || limit === Infinity || limit <= 0) {
			return 0;
		}
		return Math.min(100, Math.max(0, (usage / limit) * 100));
	}

	renderSubscriptionMetric = (metric, comparison) => {
		const exceedsSelectedLimit = comparison.isDowngrade && metric.selectedLimit !== Infinity &&
			metric.selectedLimit !== null && metric.usage !== null && metric.usage > metric.selectedLimit;
		const currentWidth = this.getSubscriptionProgressWidth(metric.usage, metric.currentLimit);
		const selectedWidth = this.getSubscriptionProgressWidth(metric.usage, metric.selectedLimit);

		return (
			<div className={`subscriptionComparisonMetric${exceedsSelectedLimit ? ' subscriptionComparisonMetric--over' : ''}`} key={metric.key}>
				<div className="subscriptionComparisonMetric__heading">
					<strong>{metric.label}</strong>
					{exceedsSelectedLimit && <span className="subscriptionComparisonMetric__warning">Current usage exceeds the new limit</span>}
				</div>
				<div className="subscriptionComparisonMetric__plans">
					<div className="subscriptionComparisonMetric__plan">
						<span>{comparison.currentPlan.name}</span>
						<strong>{this.formatSubscriptionAmount(metric.usage, metric.storage)} of {this.formatSubscriptionAmount(metric.currentLimit, metric.storage)}</strong>
						<div className="subscriptionComparisonMetric__track">
							<div className="subscriptionComparisonMetric__fill subscriptionComparisonMetric__fill--current" style={{width: `${currentWidth}%`}} />
						</div>
					</div>
					<div className="subscriptionComparisonMetric__arrow" aria-hidden="true">→</div>
					<div className="subscriptionComparisonMetric__plan">
						<span>{comparison.selectedPlan.name}</span>
						<strong>{this.formatSubscriptionAmount(metric.usage, metric.storage)} of {this.formatSubscriptionAmount(metric.selectedLimit, metric.storage)}</strong>
						<div className="subscriptionComparisonMetric__track">
							<div
								className={`subscriptionComparisonMetric__fill${exceedsSelectedLimit ? ' subscriptionComparisonMetric__fill--over' : ' subscriptionComparisonMetric__fill--selected'}`}
								style={{width: `${selectedWidth}%`}}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderSubscriptionComparison = (comparison) => {
		const {subscriptionUsageLoading, subscriptionUsageError, reloadSubscriptionUsage} = this.props;

		return (
			<div className="subscriptionComparison">
				<div className={`subscriptionComparison__summary${comparison.isDowngrade ? ' subscriptionComparison__summary--downgrade' : ''}`}>
					<span>{comparison.currentPlan.name}</span>
					<strong aria-hidden="true">→</strong>
					<span>{comparison.selectedPlan.name}</span>
				</div>
				<p className="subscriptionComparison__intro">
					Review current usage for this location before {comparison.isDowngrade ? 'downgrading' : 'upgrading'}.
				</p>
				{subscriptionUsageLoading &&
					<div className="subscriptionComparison__status">Loading current subscription usage…</div>}
				{subscriptionUsageError &&
					<div className="subscriptionComparison__status subscriptionComparison__status--error">
						Current acquisition and disposition usage could not be loaded.
						<Button type="button" color="primary" onClick={reloadSubscriptionUsage}>Try again</Button>
					</div>}
				{!subscriptionUsageLoading && !subscriptionUsageError &&
					<div className="subscriptionComparison__metrics">
						{comparison.metrics.map(metric => this.renderSubscriptionMetric(metric, comparison))}
					</div>}
				{!subscriptionUsageLoading && !subscriptionUsageError && comparison.hasUnavailableUsage &&
					<div className="subscriptionComparison__status subscriptionComparison__status--error subscriptionComparison__status--inline">
						Some current usage could not be verified. Downgrades are disabled until the usage data is available.
					</div>}
				{comparison.featureChanges.length > 0 &&
					<div className={`subscriptionComparison__features${comparison.isDowngrade ? ' subscriptionComparison__features--loss' : ''}`}>
						<h6>{comparison.isDowngrade ? 'What this location will lose' : 'What this location will gain'}</h6>
						{comparison.featureChanges.map(feature =>
							<div className="subscriptionComparison__feature" key={feature}>
								<i className={`fa ${comparison.isDowngrade ? 'fa-minus-circle' : 'fa-check-circle'}`} aria-hidden="true" />
								<span>{feature}</span>
							</div>
						)}
					</div>}
			</div>
		);
	}

	//Remove Account Module - Security for now
	removeAccountModule = (account, binary_id, pkey, name) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.DELETE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = binary_id
		moduleModel.object.account = account;
		moduleModel.object.pkey = pkey;

		try {
			await moduleModel.submit(null, API.RequestType.DELETE, true);
			API.Toast.success(name + " has been successfully removed!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	//Adds Account Module - Security for now
	submitAccountModule = ( binary_id, account, name, module) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.CREATE);

		// noinspection JSValidateTypes
		moduleModel.object.binary_id = binary_id
		moduleModel.object.account = account;
		moduleModel.object.module = module || 3;

		try {
			await moduleModel.submit(null, API.RequestType.CREATE, true);
			API.Toast.success(name + " has been successfully added!", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}


	submitCSVQuote = (module, account, binaryId, parent, location, locationBinaryId, name) => async () => {
		if (!this.model.files?.csv_import) {
			API.Toast.error('Please attach a CSV file before continuing.', {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			});
			return;
		}

		this.setState({loading: true});
		let serviceModel = new API.BuildClass(Types.Locations_Modules._name, 'POST_CSV_IMPORT');
		serviceModel.files = {
			csv_import: this.model.files.csv_import,
		};

		try {
			await serviceModel.submit(this, 'POST_CSV_IMPORT', true);
			API.Toast.success("Payment successful! We'll process your bound book import.", {
				position: API.Toast.POSITION.TOP_RIGHT,
				autoClose: 8000
			})
		} catch (e) {
		}

		this.refreshMarketPlace();
		this.setState({loading: false});
	}

	getCsvImportPayLabel(price) {
		const trimmed = (price || '').trim();
		if (!trimmed) {
			return 'Pay Now';
		}
		if (trimmed.startsWith('$')) {
			return `Pay ${trimmed} Now`;
		}
		return `Pay $${trimmed} Now`;
	}

	handleToggleModal = (modal) => {
		if (this.props.isDisabled) {
			return;
		} else {
			this.setState({[modal]: !this.state[modal]})
		}
	}

	render(props) {
		const {loading} = this.state;
		const {
			account, binaryId, modulePkey, moduleBinaryId, module, price,
			type, borderStyle, isSubscribed,
			parent,	location, locationBinaryId,	moduleClass, locationSelected,
			pkey, name,	moduleId, showName, isDisabled, handleAfterSave, key, youtubeUrl
		} = this.props;
		const cardClass = `card ${isDisabled ? 'disabled' : ''}`;
		const moduleYoutubeUrl = youtubeUrl?.trim();
		const subscriptionComparison = moduleClass === "" ? this.getSubscriptionComparison() : null;
		const subscriptionChangeDisabled = Boolean(
			subscriptionComparison && subscriptionComparison.isDowngrade &&
			(this.props.subscriptionUsageLoading || this.props.subscriptionUsageError || subscriptionComparison.hasUnavailableUsage)
		);
		//the success action button on each of the cards
		let moduleCardSuccessButton;

		if(moduleClass === 'Location Cloud Module') {
			if(isSubscribed) {
				moduleCardSuccessButton = <span>
					<div><Button type={"button"} style={{marginRight: '25px'}} class="btn btn-warning" onClick={this.removeUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}> Remove an Upgrade
					</Button><Button type={"button"} class="btn btn-primary" onClick={this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}> Add Another Upgrade</Button> </div> </span>;
			} else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name)}>Add Upgrade</Button>;
			}
		}

		else if (module === 12 && moduleClass === 'Service') {
			moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitCSVQuote(module, account, binaryId, parent, location, locationBinaryId, name)}>{this.getCsvImportPayLabel(price)}</Button>;
		}
		else if(module === 13 && moduleClass === 'Service') {
			moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={() => window.open('https://pos.karlstechnology.com/register')}>Go to POS Sign Up</Button>;
		}
		else if (moduleClass === 'Service') {
			moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary"
			                                  onClick={this.submitService(module, account, binaryId, parent, location, locationBinaryId, name)}>Request
				a Quote</Button>;
		}

		else if (module === 21) {
			if(!isSubscribed && !this.state.showApiKey) {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={this.submitApiRequest(module, account, binaryId, parent, location, locationBinaryId, name)}>Subscribe & Receive API Key</Button>;
			}
			else if (!isSubscribed && this.state.showApiKey) {
				moduleCardSuccessButton = null;

			}
			else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-danger"
				                                  onClick={moduleClass === 'Location Module' ? this.removeModule(modulePkey, moduleBinaryId, module, parent, location, locationBinaryId, name)
					                                  : this.removeAccountModule(account, binaryId, pkey, type)}>Unsubscribe</Button>;
			}

		}
		else if (moduleClass === "") {
			if (isSubscribed) {
				moduleCardSuccessButton = null;
			}
			//TODO: make this button go to the location itself? Ask Matt
			else {
				moduleCardSuccessButton = <Button
					type={"button"}
					className="btn btn-primary"
					disabled={subscriptionChangeDisabled}
					onClick={this.submitSubscription(location, locationBinaryId, moduleId, account, locationSelected, name, type)}
				>Change Plan</Button>;
			}
		}
		else {
			if(isSubscribed) {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-danger"
				                                  onClick={moduleClass === 'Location Module' ? this.removeModule(modulePkey, moduleBinaryId, module, parent, location, locationBinaryId, name)
					                                  : this.removeAccountModule(account, binaryId, pkey, type)}>Unsubscribe</Button>;
			} else {
				moduleCardSuccessButton = <Button type={"button"} class="btn btn-primary" onClick={moduleClass === 'Location Module' ?
					this.submitModule(module, account, binaryId, parent, location, locationBinaryId, name) : moduleClass === 'Location Cloud Module' ? this.submitUpgrade(module, account, binaryId, parent, location, locationBinaryId, name) :
						moduleClass === 'Account Module' ?
							this.submitAccountModule(binaryId, account, name, this.props.modulePkey || 3) :
							this.submitSubscription(location, locationBinaryId, moduleId, account, locationSelected, name, type)}>Subscribe</Button>;
			}
		}
		return (
			/**
			 * @param {Locations_Modules_Object} subscription
			 * @param i
			 * @returns {*}
			 */
			<>
				<Card
					id="moduleCard"
					style={{borderColor: borderStyle, position: 'relative'}}
					className={cardClass}
				>
					{moduleYoutubeUrl &&
						<IconButton
							component="a"
							href={moduleYoutubeUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="moduleHelpButton"
							style={{right: '46px', color: '#ff0000'}}
							aria-label={`Watch ${name} on YouTube`}
							size="small"
						>
							<YouTubeIcon fontSize="small"/>
						</IconButton>
					}
					<Tooltip
						title={type || `Learn more about ${name}`}
						placement={"left-start"}
						classes={{tooltip: 'moduleHelpTooltip'}}
					>
						<IconButton
							className={"moduleHelpButton"}
							aria-label={`Learn more about ${name}`}
							onClick={() => this.handleToggleModal('modalModuleLearnMore')}
							size={"small"}
						>
							<HelpOutlineIcon fontSize={"small"}/>
						</IconButton>
					</Tooltip>
					<CardActionArea
						onClick={() => this.handleToggleModal('modalModuleLearnMore')}
						id={"cardActionArea"}
					>
						<div className="moduleCardContent">
							<img
								src={module === 6 && moduleClass === 'Location Module' ? '/assets/images/Davidson_s_Logo_White-01.png' : '/assets/images/ffllogo.png'}
								alt={"Module Image"}
							/>
							<div className="moduleCardDetails">
								<Typography id={"cardName"} variant={"h6"} component={"h1"}>
									{name}
									{moduleClass === 'Location Cloud Module' && isSubscribed &&
										<span className="moduleCardStatus" style={{color: borderStyle}}>Currently Have: {this.props.amountSubscribed}</span>}
								</Typography>
								<p id={"description"}>{type}</p>
								<p id={"marketPlacePrice"}>{price}</p>
								<p id={"cardClassName"}>
									{moduleClass}
									{isSubscribed && <span className="moduleCardStatus" style={{color: borderStyle}}>Currently Subscribed</span>}
								</p>
							</div>
						</div>
					</CardActionArea>
				</Card>
				<Modal
					isOpen={this.state.modalModuleLearnMore}
					toggle={() => this.handleToggleModal('modalModuleLearnMore')}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader toggle={() => this.handleToggleModal('modalModuleLearnMore')}>
						{moduleClass === "" ? `${name} Subscription` : `${name} - ${moduleClass}`}
					</ModalHeader>
					<ModalBody>
						{moduleClass === "" ?
							subscriptionComparison ? this.renderSubscriptionComparison(subscriptionComparison) :
								<div className="subscriptionComparison__currentPlan">
									{isSubscribed ? <><strong>{type}</strong> is this location&apos;s current subscription.</> : type}
								</div>
							:
							<div className={"row"}>
								<div className={"col-md"}>
									<img />

									{type}
								</div>
							</div>
						}
						{module === 12 && moduleClass === 'Service' && this.state.modalModuleLearnMore === true &&
							<Framework.Elements.DropZone
								property={this.model.properties.csv_import}
								value={this.state.csv_import}
								error={this.state.csv_import_error}
								update={this.handleFileChange}
								accept={[".csv"]}
								label={'Drag \'n\' drop front csv here, or click to select csv'}
								maxSize={4e+8}
						/>}
						{module === 12 && moduleClass === 'Service' && this.state.modalModuleLearnMore === true &&
							<span>
								Please follow the <a
								href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/file_download_two`}>Template
								Spreadsheet Guide</a> for how to format your spreadsheet.
							</span>
						}
						{this.state.csv_import &&
							<span>Current Image - <b>{this.state.csv_import}</b></span>
						}
						{this.state.showApiKey &&
							<span> <br/>API Key - <b>{this.state.apiKey} </b> <br/> <i>Please save this key somewhere secure. It will also be available for viewing in your account settings.</i> </span>
						}
					</ModalBody>
					<ModalFooter style={{justifyContent: "space-between"}}>
						<Button type={"button"} class="btn btn-secondary" onClick={() => this.handleToggleModal('modalModuleLearnMore')}>Close</Button>
						{moduleCardSuccessButton}
					</ModalFooter>
				</Modal>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</>
		);
	}
}

export default Framework.Components.withRootState(ModuleCard);
